import React from "react";

/**
 * Eyebrow + Title + (optional) lead paragraph
 * Used by every section for consistent typography
 */
export default function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  accent = "text-stori-cyan",
  className = "",
  titleClassName = "",
  testId,
}) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment} ${className}`} data-testid={testId}>
      {eyebrow && (
        <div className={`label-eyebrow flex items-center gap-2 ${align === "center" ? "justify-center" : ""}`}>
          <span className={`inline-block h-px w-8 bg-stori-cyan`} />
          <span className={accent}>{eyebrow}</span>
        </div>
      )}
      <h2 className={`mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white ${titleClassName}`}>
        {title}
      </h2>
      {lead && (
        <p className="mt-6 text-lg text-stori-muted leading-relaxed max-w-2xl">
          {lead}
        </p>
      )}
    </div>
  );
}
